import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Fear and Loathing",
  "description": "",
  "published": "2006-11-19T00:00:00.000Z",
  "redirect_from": ["/blog/fear-and-loathing/swizec/354"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><img parentName="p" {...{
        "src": "/includes/editor_upload/Image/kscan_0001.png",
        "alt": "Fear and Loathing cover",
        "title": "Fear and Loathing cover"
      }}></img></p>
    <p>{`On Friday I was notified by my `}<a parentName="p" {...{
        "href": "http://www.behemot.si/"
      }}>{`favourite bookshop`}</a>{` that my copy of `}<em parentName="p">{`Fear and Loathing In Las Vegas`}</em>{` had arrived and that it is now available for pick up. The reason I had ordered the book was that the film starring Johnny Depp was, well, amazingly awesome and I wanted to see what the book was like.`}</p>
    <p>{`When I got the book I was immediatelly lured in by the interesting cover and I will probably never know if the mauled image is that of Depp or Thompson, but then again it doesn't really matter. The book was actually so good that I read it cover to cover in that same Friday. What struck me as a bit odd was that the book is no different to the film, there are of course minor differences in dialogue and some shortenings in the film. But usually after reading the book a film was made from you go `}<em parentName="p">{`Bloody hell, the film sucked compared to this, they left out too much. `}{`_`}{`In this case it was more like `}{`_`}{`Oh wow, the film is such a great enterpretation of the book it's uncanny.`}</em></p>
    <p>{`So all in all, the book was very good and I recommend everyone to give it a good read.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      